import { IconName } from '@shared/components/core/images/IconMap';
import { TinyVariant } from '@shared/constants/components/tinyUtils';
import { McpConnectionStatus } from '@shared/models/mcp/McpServerModel';
import type { TFunction } from 'i18next';

/**
 * How a server's last connection attempt reads as a tiny status pill. Shared by the server card and its
 * detail dialog so the same state never shows up in two different colours.
 */
export function statusVariant(status: McpConnectionStatus): TinyVariant {
    if (status === 'ok') return 'diminished_success';
    if (status === 'error') return 'diminished_error';
    return 'diminished';
}

/** The matching icon, so the status still reads as a connection state without the word "Connection". */
export function statusIcon(status: McpConnectionStatus): IconName {
    if (status === 'ok') return 'connectionStatusOn';
    if (status === 'error') return 'connectionOffline';
    return 'connect';
}

export function statusTitle(t: TFunction<'common'>, status: McpConnectionStatus): string {
    if (status === 'ok') return t('mcp.status.ok');
    if (status === 'error') return t('mcp.status.error');
    return t('mcp.status.unknown');
}
